import { render } from "./SnapRecordList.vue?vue&type=template&id=428873d5&scoped=true&ts=true"
import script from "./SnapRecordList.vue?vue&type=script&lang=ts"
export * from "./SnapRecordList.vue?vue&type=script&lang=ts"

import "./SnapRecordList.vue?vue&type=style&index=0&id=428873d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428873d5"]])

export default __exports__